/**
 * MercadoPago OAuth integration types
 */

/**
 * Response when MercadoPago OAuth is connected
 */
export interface MercadoPagoConnectedResponse {
  connected: true;
  user_id: string;
  expires_at: string;
  is_expired: boolean;
  expires_soon: boolean;
  is_sandbox: boolean;
  scopes: string[];
  created_at: string;
  updated_at: string;
}

/**
 * Response when MercadoPago OAuth is not connected
 */
export interface MercadoPagoNotConnectedResponse {
  connected: false;
  message: string;
}

/**
 * Union type for MercadoPago credentials check response
 */
export type MercadoPagoCredentialsResponse = 
  | MercadoPagoConnectedResponse 
  | MercadoPagoNotConnectedResponse;

/**
 * Type guard to check if user is connected
 */
export const isMercadoPagoConnected = (
  response: MercadoPagoCredentialsResponse
): response is MercadoPagoConnectedResponse => {
  const isConnected = response.connected === true;
  console.log('🔍 isMercadoPagoConnected check:', { 
    response, 
    connected: response.connected, 
    isConnected 
  });
  return isConnected;
};

/**
 * Response when starting OAuth flow (Success)
 */
export interface MercadoPagoOAuthStartResponse {
  authorization_url: string;
  state: string;
  expires_at: string;
  instructions: string;
}

/**
 * Error response when company already has active credentials (409)
 */
export interface MercadoPagoOAuthErrorResponse {
  error: string;
  expires_at: string;
  user_id: string;
}
